/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './patient-access-group.reducer';

export const PatientAccessGroupDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const patientAccessGroupEntity = useAppSelector(state => state.patientAccessGroup.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="patientAccessGroupDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.patientAccessGroup.detail.title">PatientAccessGroup</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.patientAccessGroup.id">Id</Translate>
            </span>
          </dt>
          <dd>{patientAccessGroupEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.patientAccessGroup.active">Active</Translate>
            </span>
          </dt>
          <dd>{patientAccessGroupEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.patientAccessGroup.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{patientAccessGroupEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.patientAccessGroup.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{patientAccessGroupEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.patientAccessGroup.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{patientAccessGroupEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.patientAccessGroup.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{patientAccessGroupEntity.cursor}</dd>
          <dt>
            <span id="entityType">
              <Translate contentKey="tinyMedicRestApp.patientAccessGroup.entityType">Entity Type</Translate>
            </span>
          </dt>
          <dd>{patientAccessGroupEntity.entityType}</dd>
          <dt>
            <span id="entityId">
              <Translate contentKey="tinyMedicRestApp.patientAccessGroup.entityId">Entity Id</Translate>
            </span>
          </dt>
          <dd>{patientAccessGroupEntity.entityId}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientAccessGroup.globalUser">Global User</Translate>
          </dt>
          <dd>{patientAccessGroupEntity.globalUser ? patientAccessGroupEntity.globalUser.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientAccessGroup.localUser">Local User</Translate>
          </dt>
          <dd>{patientAccessGroupEntity.localUser ? patientAccessGroupEntity.localUser.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/patient-access-group" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/patient-access-group/${patientAccessGroupEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PatientAccessGroupDetail;
